import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ViewChild, ElementRef, NgZone } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { IAddress } from 'src/app/helper/appInterfaces';

@Component({
  selector: 'app-new-address-picker',
  templateUrl: './new-address-picker.component.html',
  styleUrls: ['./new-address-picker.component.scss']
})
export class NewAddressPickerComponent implements OnInit {
  @ViewChild('search')
  public searchElementRef!: ElementRef;

  @Input() _readOnly: boolean = false;
  @Output() addressPicked = new EventEmitter<IAddress>();

  title: string = 'Address picker';
  latitude!: number;
  longitude!: number;
  zoom!: number;
  address!: string;
  postcode!: string;
  suburb!: string;
  state!: string;
  private geoCoder: any;

  constructor(private mapsAPILoader: MapsAPILoader, private ngZone: NgZone) {}

  ngOnInit() {
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      // this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder();

      const options = {
        componentRestrictions: { country: 'aus' },
        fields: ['formatted_address', 'geometry', 'name', 'address_components'],
        strictBounds: false,
        types: ['address']
      };

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, options);

      navigator.geolocation.getCurrentPosition(
        (resp) => {
          //  localize address search
          const defaultBounds = {
            north: resp.coords.latitude + 0.1,
            south: resp.coords.latitude - 0.1,
            east: resp.coords.longitude + 0.1,
            west: resp.coords.longitude - 0.1
          };

          autocomplete.setBounds(defaultBounds);
        },
        (err) => {
          console.log('err', err);
        }
      );

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(async () => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          // console.log('place', place)
          this.address = String(place.formatted_address);

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          if (place.address_components === undefined || place.address_components === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();

          this.postcode = await this.getPlaceAttr(place, 'postal_code');
          this.suburb = await this.getPlaceAttr(place, 'locality');
          this.state = await this.getPlaceAttr(place, 'administrative_area_level_1');

          this.addressPicked.emit({
            address: this.address,
            postcode: this.postcode,
            suburb: this.suburb,
            state: this.state,
            lat: this.latitude,
            lng: this.longitude
          });
        });
      });
    });
  }

  async getPlaceAttr(_place: any, _attr: string) {
    for (const component of _place.address_components) {
      const componentType = component.types[0];

      if (componentType == _attr) {
        return component.short_name;
      }
    }
  }
}
